module.exports = __webpack_public_path__ + "img/Diagnosis - Blue - Selected.5a3876e4.png";